module.exports = __webpack_public_path__ + "img/pipeline-desktop.27504333.png";